export enum loginURL {
    GOOGLE_LOGIN = "https://api.lnd.dev.coditas.org/oauth2/authorization/google?redirect_uri=http://localhost:4200/auth/login",
}